import { Config } from '@/config';
import { ApiService } from '@/services/api.service';

class TasksService {
  getOpportunityTasks({ opportunityId }) {
    return ApiService.get(`${Config.api.document.url}api/v1/opportunities/${opportunityId}/tasks`).then(
      (response) => response.data,
    );
  }

  createOpportunityTask({ task }) {
    return ApiService.post(`${Config.api.document.url}api/v1/opportunities/${task.opportunityId}/tasks`, {
      title: task.title,
      description: task.description,
      taskStatusId: task.taskStatusId,
    }).then((response) => response.data);
  }

  updateOpportunityTask({ task }) {
    return ApiService.put(`${Config.api.document.url}api/v1/opportunities/${task.opportunityId}/tasks/${task.id}`, {
      title: task.title,
      description: task.description,
      taskStatusId: task.taskStatusId,
    }).then((response) => response.data);
  }

  generateOpportunityTasks({ opportunityId }) {
    return ApiService.post(`${Config.api.document.url}api/v1/opportunities/${opportunityId}/tasks/generate`).then(
      (response) => response.data,
    );
  }

  saveOpportunityTaskAsTemplate({ opportunityId, taskId }) {
    return ApiService.post(
      `${Config.api.document.url}api/v1/opportunities/${opportunityId}/tasks/${taskId}/save-as-template`,
    ).then((response) => response.data);
  }

  deleteOpportunityTask({ opportunityId, taskId }) {
    return ApiService.delete(`${Config.api.document.url}api/v1/opportunities/${opportunityId}/tasks/${taskId}`).then(
      (response) => response.data,
    );
  }

  updateOpportunityTaskAssignees({ opportunityId, taskId, assigneeIds }) {
    return ApiService.put(
      `${Config.api.document.url}api/v1/opportunities/${opportunityId}/tasks/${taskId}/assignations`,
      {
        userIds: assigneeIds,
      },
    ).then((response) => response.data);
  }
}

export const tasksService = new TasksService();
